import React, { useContext, useEffect, useState } from 'react';
import api from '../../../services/api';

import { parseCookies } from 'nookies';
import { WidgetContext } from '../../../contexts/widgetContext';
import { RouterContext } from '../../../contexts/routerContext';

import { Container, Button } from './styles';
import { UseCron } from '../use-time';

const ReceivingCall = ({ saveContactHistories }) => {
    const { setRouter } = useContext(RouterContext);
    const {
        showReceivingCall,
        setShowReceivingCall,
        interationSIP,
        setInterationSIP,
        callInProgress,
        setCallInProgress,
        start,
    } = useContext(WidgetContext);
    const [seconds, setSeconds] = useState(0)
    const [contact, setContact] = useState(undefined)

    useEffect(() => {
        setCallInProgress({
            type: callInProgress.type,
            number: callInProgress.number,
            time: callInProgress.time,
            status: callInProgress.status,
            answered_call: callInProgress.answered_call
        })

        localStorage.setItem('@WEBPHONE.CALLINPROGRESS', JSON.stringify({
            type: callInProgress.type,
            number: callInProgress.number,
            time: callInProgress.time,
            status: callInProgress.status,
            answered_call: callInProgress.answered_call
        }))
        localStorage.setItem('@WEBPHONE.CALLINPROGRESS', JSON.stringify(callInProgress))
        const { 'bcattendant.token': token } = parseCookies()
        if (token) {
            api.get('attendant').then(response => {
                if (response.data.extension_fixed && response.data.extension_fixed.tempo_autoatend) {
                    setSeconds(response.data.extension_fixed.tempo_autoatend)
                }
                api.post(`/contacts/${response.data.id}/contact`, {
                    phone_number: callInProgress.number
                }).then(res => {
                    setContact(res.data)
                }).catch(err => {
                    console.log('Contato não encontrado!')
                });
            })
        }
    }, [])

    let time
    if (seconds > 0) {
        time = new Date()
        time.setSeconds(time.getSeconds() + seconds)
    }


    const handleAcceptCall = () => {
        document.getElementById("webphone-audio").pause();
        setInterationSIP(interationSIP.acceptIncomingCall())
        setCallInProgress({
            type: 'Entrada',
            number: callInProgress.number,
            time: '',
            status: 'Progress',
            answered_call: 'SIM'
        })
        setShowReceivingCall(false);
        start()
        setRouter('call-in-progress')
    }

    const handleRecuseCall = async () => {
        document.getElementById("webphone-audio").pause();
        await saveContactHistories(callInProgress.number, 'Chamada Recusada', '00:00:00', 'NAO')
        localStorage.removeItem('@WEBPHONE.CALLINPROGRESS')
        interationSIP.hangupIncomingCall();
        setShowReceivingCall(false);
        setCallInProgress({
            type: '',
            number: '',
            time: '',
            status: '',
            answered_call: ''
        })
    }
    return (
        <Container open={showReceivingCall}>
            <h1>Chamada de voz</h1>
            <span>{contact ? contact.name : callInProgress.number}</span>
            <div>
                <Button
                    backgroundColor='linear-gradient(0deg, #42DC3F, #42DC3F), #A7A7A7'
                    onClick={() => handleAcceptCall()}
                >
                    {time ? (
                        <UseCron expiryTimestamp={time} handleAcceptCall={handleAcceptCall} />
                    ) : 'Atender'}
                </Button>
                <Button
                    backgroundColor='linear-gradient(0deg, #FF0000, #FF0000), #A7A7A7'
                    onClick={() => handleRecuseCall()}
                >
                    Desligar
                </Button>
            </div>
        </Container>
    );
}

export default ReceivingCall;